export const round = (value, precision = 0) => {
  if (!Number.isInteger(precision)) throw new Error('precision must be an integer');
  const base = 10 ** precision; 
  return Math.round((value + Number.EPSILON) * base) / base;
};
